import React from "react";
import Title from "../components/Title";
import Service from "../components/Service";
import Einleitung from "../components/Einleitung";
import Mittellauf from "../components/Mittellauf";
import Oberlauf from "../components/Oberlauf";
import Leihboote from "../components/Leihboote";
import Bootsangler from "../components/Bootsangler";
import Eigenesboot from "../components/Eigenesboot";
import Guiding from "../components/Guiding";
import Preise from "../components/Preise";
import Events from "../components/Events";
import Filme from "../components/Filme";

import "semantic-ui-css/semantic.min.css";
import "../css/styles.css";
import "../css/swiper.css";
import "../css/pricing.css";

class IndexPage extends React.Component {
  render() {
    return (
      <div className="divided Site-content">
        <Title />
        <Einleitung />
        <Service />
        <Mittellauf />
        {/*<Oberlauf />*/}
        {/*<Tour100/>*/}
        <Leihboote />
        <Bootsangler />
        <Eigenesboot />
        <Guiding />
        {/*<Team/>*/}
        <Preise />
        <Events />
        <Filme />
        <br />
        <br />
        <br />
      </div>
    );
  }
}

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js